import Builder from "./Builder";

export {Builder};

export default Builder.resolver();
